import { useTextLocalizer } from './useTextLocalizer';

/**
 * A wrapper around useTextLocalizer. Only for components in Nova commons.
 *
 * @param novaComponent
 */
export const useNCTextLocalizer = novaComponent => useTextLocalizer(`NovaComponents-${novaComponent}-gui-icu`);
//# sourceMappingURL=useNCTextLocalizer.js.map